import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'spareParts.recurrentProblem.title',
        defaultMessage: 'Recurrent Problems'
    },
    EMPTY: {
        id: 'spareParts.recurrentProblem.empty',
        defaultMessage: 'There is no recurrent problem defined'
    },
    TABLE_PROBLEM_NUMBER: {
        id: 'spareParts.recurrentProblem.table.problemNumber',
        defaultMessage: 'Problem number'
    },
    TABLE_PROBLEM_TITLE: {
        id: 'spareParts.recurrentProblem.table.problemTitle',
        defaultMessage: 'Problem title'
    },
    TABLE_ATTACHMENT: {
        id: 'spareParts.recurrentProblem.table.attachment',
        defaultMessage: 'Attachment'
    },
    TABLE_LAST_UPDATE: {
        id: 'spareParts.recurrentProblem.table.lastUpdate',
        defaultMessage: 'Last update'
    },
    SELECT_COUNTRY: {
        id: 'spareParts.recurrentProblem.selectCountry',
        defaultMessage: 'Select a country'
    },
});

export default messages;
